
import React from "react";
import { Copy, Share2 } from "lucide-react";
import { ElfNameGeneratorTheme } from "./ElfNameGeneratorTheme";
import { ElfName } from "./ElfNameGenerator";

interface GeneratedNameProps {
  name: ElfName;
  fullName: boolean;
  isGenerating: boolean;
  onCopy: () => void;
  onShare: () => void;
  copied: boolean;
}

export const GeneratedName: React.FC<GeneratedNameProps> = ({
  name,
  fullName,
  isGenerating,
  onCopy,
  onShare,
  copied
}) => {
  if (isGenerating) {
    return (
      <div className={`${ElfNameGeneratorTheme.nameContainer} animate-pulse`}>
        <div className="h-6 w-3/4 bg-gray-200 rounded mx-auto mb-3"></div>
        <div className="h-8 bg-gray-300 rounded mx-auto w-2/3"></div>
      </div>
    );
  }
  
  return (
    <div className={ElfNameGeneratorTheme.nameContainer}>
      <div className={ElfNameGeneratorTheme.namePrefix}>Your Christmas Elf Name is:</div>
      <div className={`${ElfNameGeneratorTheme.nameDisplay} ${ElfNameGeneratorTheme.scaleIn}`}>
        {name.firstName} {fullName && name.lastName}
      </div>
      
      <div className={ElfNameGeneratorTheme.nameActions}>
        <button 
          onClick={onCopy} 
          className={ElfNameGeneratorTheme.actionButton}
          aria-label="Copy to clipboard"
        >
          <Copy className={ElfNameGeneratorTheme.actionIcon} />
          {copied ? "Copied!" : "Copy"}
        </button>
        
        <button 
          onClick={onShare} 
          className={ElfNameGeneratorTheme.actionButton}
          aria-label="Share"
        >
          <Share2 className={ElfNameGeneratorTheme.actionIcon} />
          Share
        </button>
      </div>
    </div>
  );
};
